import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import React from 'react';

export const LoadingGridPanel: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <div className="k-loading-mask">
      <span className="k-loading-text">{translate('custom.common.loadingText')}</span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );
};
